import { vestResolver } from "@hookform/resolvers/vest";
import { getVestValidateEmail } from "application/utils";
import { create, test } from "vest";

const schema = create((data = {}) => {
  test("email", "Email is not valid", getVestValidateEmail(data.email));
});

export default vestResolver(schema);
